export const comments_3294070 = {"data":{"data":[],"links":{}}}